"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get filterInternalDependencies () {
        return filterInternalDependencies;
    },
    get resolveInternalDependencies () {
        return resolveInternalDependencies;
    }
});
const _workspacetools = require("workspace-tools");
function filterInternalDependencies(dependencies, workspaces) {
    const workspacePackageNames = (0, _workspacetools.listOfWorkspacePackageNames)(workspaces);
    return Object.keys(dependencies).filter((dependency)=>workspacePackageNames.indexOf(dependency) >= 0);
}
function resolveInternalDependencies(allDependencies, workspaces) {
    const dependencyNames = filterInternalDependencies(allDependencies, workspaces);
    return dependencyNames;
}
